import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["scaleItems", "scaleRow"]

  addRow() {
    const tbody = this.scaleItemsTarget
    const rows = tbody.querySelectorAll("tr[data-council-mention-scale-target='scaleRow']")
    const lastRow = rows[rows.length - 1]

    // Get last max value to set as new min
    let newMin = 0
    if (lastRow) {
      const maxInput = lastRow.querySelector("input[name*='[max]']")
      if (maxInput && maxInput.value) {
        newMin = (parseFloat(maxInput.value) + 0.01).toFixed(2)
      }
    }

    // GO4S Design System : la ligne clonée reflète le markup statique de _form.html.erb
    const newRow = document.createElement("tr")
    newRow.setAttribute("style", "border-top:1px solid var(--ds-border);")
    newRow.setAttribute("data-council-mention-scale-target", "scaleRow")

    // Build options from existing select
    let optionsHtml = '<option value="">--</option>'
    const existingSelect = tbody.querySelector("select[name*='[council_mention_key]']")
    if (existingSelect) {
      existingSelect.querySelectorAll("option:not([value=''])").forEach(opt => {
        optionsHtml += `<option value="${opt.value}">${opt.textContent}</option>`
      })
    }

    newRow.innerHTML = `
      <td style="padding:12px 16px;">
        <select name="council_mention_scale[scale_items][][council_mention_key]" style="min-width:180px;">
          ${optionsHtml}
        </select>
      </td>
      <td style="padding:12px 16px;">
        <input type="number" name="council_mention_scale[scale_items][][min]" value="${newMin}"
               min="0" max="20" step="0.01">
      </td>
      <td style="padding:12px 16px;">
        <input type="number" name="council_mention_scale[scale_items][][max]" value="20"
               min="0" max="20" step="0.01">
      </td>
      <td style="padding:12px 8px;">
        <button type="button" data-action="council-mention-scale#removeRow"
                class="ds-iconbtn ds-iconbtn--danger ds-iconbtn--sm">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/></svg>
        </button>
      </td>
    `

    tbody.appendChild(newRow)
  }

  removeRow(event) {
    const row = event.target.closest("tr[data-council-mention-scale-target='scaleRow']")
    const tbody = this.scaleItemsTarget
    const rows = tbody.querySelectorAll("tr[data-council-mention-scale-target='scaleRow']")

    // Don't allow removing if only 1 row left
    if (rows.length <= 1) return

    row.remove()
  }
}
